import { useState } from 'react'

import { num } from '../formato'

/**
 * El embudo del periodo como barras horizontales de UNA serie (magnitud): un solo color,
 * la cifra escrita al final de cada barra y un tooltip al pasar por encima. Sin paleta
 * categorica: todas las barras miden lo mismo (personas o versiones).
 */

export interface Etapa {
  etiqueta: string
  valor: number
  detalle: string
}

// Pensado para media columna (~400 px): con 720 las etiquetas quedaban diminutas.
const ANCHO = 420
const ALTO_FILA = 34
const IZQUIERDA = 130
const DERECHA = 44
const RADIO = 4

export function GraficoEmbudo({ etapas }: { etapas: Etapa[] }) {
  const [activa, setActiva] = useState<number | null>(null)
  const maximo = Math.max(1, ...etapas.map((e) => e.valor))
  const largo = (v: number) => (v / maximo) * (ANCHO - IZQUIERDA - DERECHA)
  const alto = etapas.length * ALTO_FILA

  return (
    <figure className="grafico embudo">
      <div className="grafico-lienzo">
        <svg viewBox={`0 0 ${ANCHO} ${alto}`} role="img" aria-label="Embudo del periodo">
          {etapas.map((e, i) => {
            const y = i * ALTO_FILA + 5
            const l = largo(e.valor)
            const r = Math.min(RADIO, l / 2)
            return (
              <g key={e.etiqueta} onMouseEnter={() => setActiva(i)} onMouseLeave={() => setActiva(null)}>
                {/* Zona de hover mas grande que la barra: una barra de 0 tambien tiene tooltip. */}
                <rect x={0} y={i * ALTO_FILA} width={ANCHO} height={ALTO_FILA} fill="transparent" />
                <text className="eje-etiqueta" x={IZQUIERDA - 10} y={y + 17} textAnchor="end">
                  {e.etiqueta}
                </text>
                {l > 0 && (
                  <path
                    className={activa === i ? 'barra-embudo activa' : 'barra-embudo'}
                    d={`M${IZQUIERDA},${y} H${IZQUIERDA + l - r} Q${IZQUIERDA + l},${y} ${IZQUIERDA + l},${y + r} V${y + 24 - r} Q${IZQUIERDA + l},${y + 24} ${IZQUIERDA + l - r},${y + 24} H${IZQUIERDA} Z`}
                  />
                )}
                <text className="rotulo" x={IZQUIERDA + l + 8} y={y + 17}>
                  {num(e.valor)}
                </text>
              </g>
            )
          })}
        </svg>
        {activa !== null && (
          <div className="tooltip" style={{ left: `${((IZQUIERDA + largo(etapas[activa]!.valor)) / ANCHO) * 100}%`, top: `${(activa * ALTO_FILA) / alto * 100}%` }}>
            <strong>{etapas[activa]!.etiqueta}: {num(etapas[activa]!.valor)}</strong>
            <span>{etapas[activa]!.detalle}</span>
          </div>
        )}
      </div>
      <figcaption className="suave">
        Conteos del periodo, no una cohorte: un cliente cotizado hoy pudo llegar como lead hace meses.
      </figcaption>
    </figure>
  )
}
